import React from "react";
import { RadioButtonGroup, RadioButton } from "material-ui";

export const OPTIONS = {
  CURRENT: "single",
  FUTURE: "future",
  ALL: "all"
};

export default class extends React.Component {
  render() {
    const { hideCurrent, value, onChange } = this.props;
    return (
      <RadioButtonGroup
        name="option"
        valueSelected={value}
        onChange={(e, v) => onChange(v)}
      >
        <RadioButton value={OPTIONS.ALL} label={`All events`} />
        <RadioButton
          value={OPTIONS.FUTURE}
          label={`This and all following events`}
        />
        <RadioButton
          value={OPTIONS.CURRENT}
          label={`This event only`}
          style={{ display: hideCurrent ? "none" : "block" }}
        />
      </RadioButtonGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/partials/events/recurring-update-options.jsx